// src/components/math/MathRenderer.js
import React, { useEffect, useRef, useState } from 'react';
import { MathUtils } from './MathUtils';

const MathRenderer = ({ content, className, style }) => {
  const containerRef = useRef(null);
  const [html, setHtml] = useState('');

  useEffect(() => {
    let mounted = true;
    const process = async () => {
      const processed = await MathUtils.processContentWithMarkdown(content || '');
      if (mounted) {
        setHtml(processed);
      }
    };
    process();
    return () => {
      mounted = false;
    };
  }, [content]);

  useEffect(() => {
    if (!containerRef.current) return;
    MathUtils.renderMath(containerRef.current);
  }, [html]);

  if (!content) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={["math-renderer", className].filter(Boolean).join(' ')}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default MathRenderer;
